export type MotionMode = 'cinematic' | 'subtle' | 'still';

export const EASE_CINEMATIC = [0.22, 1, 0.36, 1] as const;
